module.exports = __webpack_public_path__ + "img/preco_dependente.98cd2d71.png";